// extracted by mini-css-extract-plugin
export default {"photosPage":"Photos_photosPage__bXdCu","folderList":"Photos_folderList__p8yxZ","folderButton":"Photos_folderButton__ZwENO","backButton":"Photos_backButton__Yv6F6"};